module.exports = __webpack_public_path__ + "static/media/bene.db023d0c.png";